export default __webpack_public_path__ + "static/media/InageiAnelvdodiMacOSX.060ba01e.pkg";